var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41602 28.9955V48.5957L23.3045 58.9248V38.2599L5.48438 27.9734C5.43926 28.3097 5.41602 28.6511 5.41602 28.9955V28.9955Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1639 62.3082L47.0703 72.6475V51.9787L29.1639 41.6422V62.3082Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 26.2356L32.0963 36.5694L50 46.9043L67.9037 36.5694L50 26.2356Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9297 72.6475L70.8361 62.3082V41.6422L52.9297 51.9787V72.6475Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5154 27.9734L76.6953 38.2599V58.9248L94.5838 48.5957V28.9955C94.584 28.6511 94.5607 28.3097 94.5154 27.9734V27.9734Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7303 22.3186C86.6283 19.9483 80.3012 16.2936 73.7645 12.5188L55.8605 22.8528L73.7641 33.1866L91.5908 22.8961C91.319 22.686 91.032 22.4924 90.7303 22.3186V22.3186Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9049 9.13555C62.5875 6.06562 57.534 3.14883 53.857 1.02832C52.6678 0.342773 51.334 0 50.0002 0C48.6662 0 47.3322 0.342773 46.1424 1.02871C42.5465 3.10664 37.4787 6.03242 32.099 9.13769L50 19.4701L67.9049 9.13555Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2387 12.5205C19.8055 16.234 13.5168 19.8643 9.27266 22.3168C8.96973 22.4914 8.68204 22.6855 8.40958 22.8965L26.2359 33.1867L44.1395 22.8529L26.2387 12.5205Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41602 71.5785C5.41602 74.3271 6.89277 76.8855 9.26973 78.2556L9.27266 78.2574C12.8678 80.3347 17.9301 83.2576 23.3045 86.3599V65.6908L5.41602 55.3617V71.5785Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1639 89.7421C35.6023 93.4587 41.8977 97.0927 46.1451 99.547C46.4451 99.7199 46.7543 99.8707 47.0703 99.9999V79.4134L29.1639 69.074V89.7421Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9297 99.9996C53.2467 99.8701 53.5568 99.7189 53.8576 99.5455C58.2055 97.0378 64.4783 93.4171 70.8359 89.7462V69.074L52.9297 79.4134V99.9996Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6955 86.3627C82.1549 83.21 87.2441 80.2702 90.7273 78.2573C93.1074 76.8856 94.5842 74.327 94.5842 71.5786V55.3616L76.6957 65.6907V86.3627H76.6955Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/Sessions.6e8c891d3e59b8d2e2c725e430081e91.svg";
export { ForwardRef as ReactComponent };